import { render, staticRenderFns } from "./UM_terminalOffset.vue?vue&type=template&id=83bfce60&scoped=true&"
import script from "./UM_terminalOffset.vue?vue&type=script&lang=js&"
export * from "./UM_terminalOffset.vue?vue&type=script&lang=js&"
import style0 from "./UM_terminalOffset.vue?vue&type=style&index=0&id=83bfce60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bfce60",
  null
  
)

export default component.exports